import { Box, Typography } from '@material-ui/core'
import PostAddIcon from '@mui/icons-material/PostAdd'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import Button from '@mui/material/Button'
import { useEffect, useState } from 'react'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined'
import { getAssociatedTickets, getTickets } from '../api'
import { useDebounce } from '../../../hooks/useDebounce'
import { ZendeskPluginLink } from '../ZendeskPluginLink'
import { TicketCard } from '../components/TicketCard'
import { ZendeskPluginCTA } from '../components/CTA'
import config from '../../../config'
import { FixedMainButton } from '../components/FixedMainButton'
import { ConfirmationModal } from '../components/CreateTicketConfirmationModal'

export const ZendeskPluginHome = () => {
  const [currentZendeskTicket, setCurrentZendeskTicket] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [linkedInternalTickets, setLinkedInternalTickets] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [showHomePage, setShowHomePage] = useState(true)
  const [unlinkedInternalTickets, setUnlinkedInternalTickets] = useState([])
  const [openModal, setOpenModal] = useState(false)

  const DEBOUNCE_DELAY = 1000
  const debouncedSearchValue = useDebounce(searchValue, DEBOUNCE_DELAY)

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const client = ZAFClient.init()

    client.get('ticket').then((data) => {
      if (data?.ticket) {
        setCurrentZendeskTicket({
          zendeskId: data.ticket.id,
          requester: data.ticket.requester.email,
          status: data.ticket.status,
          subject: data.ticket.subject,
          channel: data.ticket.via.channel,
          assignee: data.ticket.assignee?.user?.email,
          createdAt: data.ticket.createdAt,
          updatedAt: data.ticket.updatedAt,
        })
        setIsLoading(false)
      }
    })
  }, [])

  useEffect(() => {
    if (currentZendeskTicket) {
      getAssociatedTickets(currentZendeskTicket.zendeskId).then((data) => {
        setLinkedInternalTickets(data)
      })
    }
  }, [currentZendeskTicket])

  useEffect(() => {
    if (!showHomePage) {
      setIsLoading(true)
      getTickets(debouncedSearchValue).then((data) => {
        const initialTickets = data.map((ticket) => ({
          ...ticket,
          isChecked: false,
        }))
        setUnlinkedInternalTickets(initialTickets)
        setIsLoading(false)
      })
    }
  }, [showHomePage, debouncedSearchValue])

  const handleOnAddTicketClick = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  if (isLoading) {
    return <Box>Loading...</Box>
  }

  return (
    <Box
      sx={{
        margin: '0px 10px 10px 10px',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          borderBottom: '1px solid black',
          marginBottom: '20px',
        }}
      >
        <Box
          sx={{
            width: '50%',
          }}
        >
          {showHomePage ? (
            <Typography variant="h5">Tickets HelloApp</Typography>
          ) : (
            <Button
              variant="text"
              onClick={() => setShowHomePage(true)}
              startIcon={<ArrowBackIosOutlinedIcon />}
            >
              Retour
            </Button>
          )}
        </Box>
        <Box
          sx={{
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            marginBottom: '10px',
          }}
        >
          <ZendeskPluginCTA
            icon={<PostAddIcon />}
            title="Créer un ticket"
            onClick={handleOnAddTicketClick}
          />
          <ZendeskPluginCTA
            icon={<HomeOutlinedIcon />}
            title="Voir tous les tickets"
            onClick={() =>
              window.open('https://syndic.manda.fr/tickets', '_blank')
            }
          />
          <ZendeskPluginCTA
            icon={<SendOutlinedIcon />}
            onClick={() =>
              window.open('https://syndic.manda.fr/massmails', '_blank')
            }
            title="Envoyer un mail en masse"
          />
        </Box>
      </Box>

      {!showHomePage ? (
        <ZendeskPluginLink
          setShowHomePage={setShowHomePage}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          unlinkedInternalTickets={unlinkedInternalTickets}
          currentZendeskTicket={currentZendeskTicket}
          setUnlinkedInternalTickets={setUnlinkedInternalTickets}
          setLinkedInternalTickets={setLinkedInternalTickets}
        />
      ) : (
        <Box>
          {linkedInternalTickets?.length > 0 ? (
            linkedInternalTickets.map((ticket, index) => (
              <TicketCard
                key={ticket.id}
                ticket={ticket}
                zendeskTicketId={currentZendeskTicket.zendeskId}
                setLinkedInternalTickets={setLinkedInternalTickets}
                linkedTicketsMode
                isLastCard={index === linkedInternalTickets.length - 1}
              />
            ))
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                height: '80vh',
                marginY: '20px',
              }}
            >
              <Typography variant="h6">Aucun ticket rattaché</Typography>
              <img
                src={`${config.PUBLIC_URL}/img/mandy_no-result.png`}
                style={{
                  width: '40%',
                }}
              />
            </Box>
          )}

          <FixedMainButton
            title="Rattacher un ticket"
            handleOnClick={() => setShowHomePage(false)}
          />
        </Box>
      )}
      <ConfirmationModal
        zendeskId={currentZendeskTicket.zendeskId}
        handleCloseModal={handleCloseModal}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Box>
  )
}
